import { EventEmitter } from '@angular/core';
import { ColumnHeaderFilterType, IFilterEvent } from './abstractions/filter.interface';
import { PaginatorModel } from './paginator.model';
import { SortModel } from './sort.model';

export class StateModel {
  private readonly _sort: SortModel;
  private readonly _paginator: PaginatorModel;
  private readonly _filters: FilterModel[];
  private _columnFilters: Map<string, IFilterEvent>;
  private _textFilter: string;

  constructor() {
    this._sort = new SortModel();
    this._paginator = new PaginatorModel();
    this._filters = [];
    this._columnFilters = new Map<string, IFilterEvent>();
  }

  private _propertyChange: EventEmitter<void>;

  get propertyChange(): EventEmitter<void> {
    return this._propertyChange;
  }

  get sort(): SortModel {
    return this._sort;
  }

  get paginator(): PaginatorModel {
    return this._paginator;
  }

  get columnFilters(): Map<string, IFilterEvent> {
    return this._columnFilters;
  }

  get filters(): FilterModel[] {
    return this._filters;
  }

  get textFilter(): string {
    return this._textFilter;
  }

  set textFilter(textfilter: string) {
    this._textFilter = textfilter;
  }

  public filtersToQueryString(): string {
    const params: string[] = [];

    this._filters.forEach(filter => {
      params.push(
        `filter=${encodeURIComponent(filter.category)}[${encodeURIComponent(filter.operator)}]${encodeURIComponent('=')}${encodeURIComponent(filter.value)}`
      );
    });

    return params.join('&');
  }

  public columnFiltersToQueryString(): string {
    const params: string[] = [];

    this._columnFilters.forEach((filter: IFilterEvent) => {
      if (filter.type === ColumnHeaderFilterType.Date && !isNaN(Date.parse(filter.value))) {
        const startDate = new Date(filter.value);
        const endDate = new Date(startDate);
        endDate.setDate(endDate.getDate() + 1);

        params.push(
          `filter=${encodeURIComponent(filter.key)}[GreaterThan]=${encodeURIComponent(startDate.toISOString())}`
        );
        params.push(
          `filter=${encodeURIComponent(filter.key)}[LessThan]=${encodeURIComponent(endDate.toISOString())}`
        );
      }
      else if (filter.value.includes(',')) {
        const values = filter.value.split(',');
        const parsedStartDate = Date.parse(values[0]);
        const parsedEndDate = Date.parse(values[1]);
        if (values.length == 2 && !isNaN(parsedStartDate) && !isNaN(parsedEndDate)) {
          params.push(
            `filter=${encodeURIComponent(filter.key)}[GreaterThan]=${encodeURIComponent(new Date(parsedStartDate).toISOString())}`
          );
          const endDate = new Date(parsedEndDate);
          endDate.setDate(endDate.getDate() + 1);
          params.push(
            `filter=${encodeURIComponent(filter.key)}[LessThan]=${encodeURIComponent(new Date(endDate).toISOString())}`
          );
        } else params.push(`filter=${encodeURIComponent(filter.key)}[In]=${encodeURIComponent(filter.value)}`);
      } else {
        params.push(`filter=${encodeURIComponent(filter.key)}[Contains]=${encodeURIComponent(filter.value)}`);
      }
    });

    return params.join('&');
  }
}

export interface FilterModel {
  title: string;
  category: string;
  operator: string;
  value: string;
}

export enum FilterColumnType {
  string,
  dateTime,
  int,
  decimal,
  stringList,
}

export interface FilterColumn {
  name: string;
  title: string;
  type: FilterColumnType;
}
